import { useQuery } from '@tanstack/react-query';
import api from '../../../shared/api/client';

export function useLastCalcDate({ enabled = true } = {}) {
  return useQuery({
    queryKey: ['reports', 'last-calc'],
    queryFn: async () => {
      const { data } = await api.get('/reports/last-calc');
      return data?.last_calc_date || null;
    },
    enabled,
    staleTime: 60_000,
    retry: false,
  });
}
